export default __webpack_public_path__ + "static/media/eye-slash-regular.7e5c64cf.svg";